import 'polyfills';

import ReactOnRails from 'react-on-rails';

import RoofGawkingIndex from "../../components/Widgets/Roofing/RoofGawkingWidget/Index";

ReactOnRails.register({
  'Widgets::Roofing::RoofGawkingWidget::Index': RoofGawkingIndex,
});
